import CentralMappingMappingEntrySerializer from 'lumen/serializers/central-mapping/mapping-entry';

export default class CentralMappingMappingEntryMarketSegmentSerializer extends CentralMappingMappingEntrySerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      return super.modelNameFromPayloadKey(
        'central-mapping/mapping-entry-market-segment',
      );
    }

    return key;
  }
}
